import type { VendorKpiCategory } from '@/types/vendor-kpi.ts';
import KPICategoryCard from './KPICategoryCard.tsx';

interface KPIDetailGridProps {
  categories: VendorKpiCategory[];
  teamCategories?: VendorKpiCategory[];
}

export default function KPIDetailGrid({ categories, teamCategories }: KPIDetailGridProps) {
  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {categories.map((cat) => {
        const teamCat = teamCategories?.find((tc) => tc.id === cat.id);
        return (
          <KPICategoryCard
            key={cat.id}
            category={cat}
            teamScore={teamCat?.score}
          />
        );
      })}
    </div>
  );
}
